import { render, staticRenderFns } from "./CallsList.vue?vue&type=template&id=e8ed5e88&scoped=true&lang=pug"
import script from "./CallsList.vue?vue&type=script&lang=js"
export * from "./CallsList.vue?vue&type=script&lang=js"
import style0 from "./CallsList.vue?vue&type=style&index=0&id=e8ed5e88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ed5e88",
  null
  
)

export default component.exports